import { render, staticRenderFns } from "./basePlanDetail.vue?vue&type=template&id=246b7ed2&scoped=true&"
import script from "./basePlanDetail.vue?vue&type=script&lang=ts&"
export * from "./basePlanDetail.vue?vue&type=script&lang=ts&"
import style0 from "./basePlanDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./basePlanDetail.vue?vue&type=style&index=1&id=246b7ed2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246b7ed2",
  null
  
)

export default component.exports